<template>
    <LoaderComponent v-if="isLoading && caracteristiques.length === 0" />
    <div v-else class="table-container">
        <DataTable :isLoading="isLoading" :not-sticky="true" :tableData="caracteristiques" :tableHeader="tableHeader" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { CaracteristiqueArticle } from '@/models/CaracteristiqueArticle';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import DataTable from '@/components/ui-components/DataTable.vue';
import i18n from '@/plugins/i18n';

export default defineComponent({
    name: 'CaracteristiquesEquipement',
    components: { LoaderComponent, DataTable },
    beforeMount() {
        // store.dispatch(EquipementInterventionsActions.GET_CARACTERISTIQUES_EQUIPEMENT, state.equipementId);
    },
    data() {
        const tableHeader: TableHeader[] = [
            {
                label: i18n.global.t('modale.equipment.characteristic.label'),
                sortStatus: SortType.INACTIVE,
                sortData: '',
                width: '33%',
            },
            {
                label: i18n.global.t('modale.equipment.characteristic.value'),
                sortStatus: SortType.INACTIVE,
                sortData: '',
                width: '33%',
            },
            {
                label: i18n.global.t('modale.equipment.characteristic.unit'),
                sortStatus: SortType.INACTIVE,
                sortData: '',
                width: '33%',
            },
        ];
        return {
            tableHeader,
        };
    },
    computed: {
        isLoading(): boolean {
            return this.$store.getters.getCaracteristiquesEquipementLoading;
        },
        caracteristiques(): [] {
            return this.$store.getters.getCaracteristiquesEquipement.map((c: CaracteristiqueArticle) => {
                return {
                    libelle: c.libelle,
                    valeur: c.valeur,
                    uniteMesure: c.uniteMesure,
                };
            });
        },
    },
});
</script>

<style scoped></style>
